<template>
<div id="ap_claves_documento" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-top justify-top>
            <v-menu-lateral-apendice />
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Tipos de Documentos" class="elevation-1 px-5 py-3" >
                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-speed-dial direction="left" open-on-hover>
                            <template v-slot:activator>
                                <v-btn x-small fab dark color="primary" >
                                    <v-icon>reorder</v-icon>
                                </v-btn>
                            </template>

                            <exportar-excel :data="datafiltered" :exportFields="camposexcel" name="Tipos de Documentos.xlsx" >
                                <v-btn fab dark x-small color="success" title="Exportar Registros" v-tippy>
                                    <v-icon dark>get_app</v-icon>
                                </v-btn>
                            </exportar-excel>
                            <upload-excel-component v-if="editable" :on-success="handleSuccess" :before-upload="beforeUpload" />
                            <exportar-excel v-if="editable" :data="camposLayout" :exportFields="encabezadoLayout" name="Layout Tipos de Documentos.xlsx" >
                                <v-btn fab dark x-small color="purple darken-2" title="Descargar Layout" v-tippy>
                                    <v-icon dark>receipt</v-icon>
                                </v-btn>
                            </exportar-excel>
                        </v-speed-dial>
                        &nbsp;
                        <v-btn v-if="editable" fab dark x-small color="secondary" slot="activator" @click.native="openModal(1)" title="Agregar Registro" v-tippy>
                            <v-icon dark>add</v-icon>
                        </v-btn>

                        <v-dialog v-model="modal" max-width="60%" style=" z-index: 400 !important;" >
                            <v-card>
                                <v-card-title>
                                    <v-card class="primary white--text titulomodal" >
                                        <v-icon class="white--text" >
                                            {{update ? "edit" : "add"}}
                                        </v-icon>&nbsp;
                                        <span class="subheading" >
                                            <strong>
                                                {{ update ? "Actualizar" : "Nuevo" }} Registro
                                            </strong>
                                        </span>
                                    </v-card>
                                    <v-spacer></v-spacer>
                                    <v-btn icon @click.native="modal = false" class="close_modal" >
                                        <v-icon class="white--text" >cancel</v-icon>
                                    </v-btn>
                                </v-card-title>
                                <v-form ref="form" lazy-validation>
                                    <v-card-text>
                                        <v-container grid-list-md text-xs-center @keyup.enter="guardar()" >
                                            <v-row>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-text-field label="Clave" type="text" v-model="model.clave" @input="model.clave = model.clave.toUpperCase()" :rules="[rules.required]" maxlength="10" ></v-text-field>
                                                </v-col>
                                                <v-col xs="12" sm="8" md="8" lg="8" >
                                                    <v-text-field label="Descripción" type="text" v-model="model.descripcion" maxlength="250" :rules="[rules.required]" ></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-checkbox v-model="model.recibe_facturas" label="Recibe Facturas xml" :true-value="1" :false-value="0"
                                                        ></v-checkbox>                                                    
                                                </v-col>
                                                <v-col xs="12" sm="4" md="4" lg="4" >
                                                    <v-checkbox v-model="model.recibe_layouts" label="Recibe Layouts xlsx" :true-value="1" :false-value="0"
                                                        ></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>
                                </v-form>
                                <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn @click.native="modal = false" >
                                        <v-icon>cancel</v-icon>Cancelar
                                    </v-btn>
                                    <v-btn color="success" :loading="loading" @click.native="guardar()" >
                                        <v-icon>done</v-icon>
                                        {{ update ? "Actualizar" : "Guardar" }}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-card-actions>

                    <v-card-text>
                        <div id="datagrid" >
                            <v-client-table ref="principalTable" :data="items" :columns="columns" :options="options" class="elevation-2 pa-2" >
                                <template slot="noResults" >
                                    <v-alert :value="true" icon="info" color="info" >No se encontró ningún registro</v-alert>
                                </template>
                                <template v-if="false" slot="layouts" slot-scope="props" >                                    
                                    <exportar-excel v-if="verificaClave170(props.row.clave)" 
                                        :data="camposFactura170" :exportFields="encabezadoFacturaLayout" name="Layout Facturas Mercancías.xlsx" >
                                        <v-btn fab dark x-small color="purple darken-2" title="Layout Facturas Mercancías" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                    <exportar-excel v-if="verificaClaveP020(props.row.clave)" 
                                        :data="camposFacturaP020" :exportFields="encabezadoFacturaLayout" name="Layout Facturas Gastos.xlsx" >
                                        <v-btn fab dark x-small color="blue darken-2" title="Layout Facturas Gastos" v-tippy>
                                            <v-icon dark>receipt</v-icon>
                                        </v-btn>
                                    </exportar-excel>
                                </template>

                                <template slot="actions" slot-scope="props" >
                                    <v-speed-dial :id="props.row.id" direction="left" open-on-hover>
                                        <template v-slot:activator>
                                            <v-btn :id="props.row.id" x-small fab dark color="primary" >
                                                <v-icon>reorder</v-icon>
                                            </v-btn>
                                        </template>

                                        <v-btn x-small fab dark color="blue" @click.native="
                                            getRegistro(props.row.id)
                                            " title="Editar Registro" v-tippy>
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                        <v-btn x-small fab dark color="pink" @click.native="
                                            deleteRegistro(props.row.id)
                                            " title="Eliminar Registro" v-tippy>
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </v-speed-dial>
                                </template>

                            </v-client-table>
                        </div>
                    </v-card-text>
                </base-material-card>
            </v-flex>

        </v-layout>
    </v-container>

</div>
</template>

<script>
import axios from "axios";
import menuLateral from "@/views/apendices/MenuLateralApendice.vue";
import powerTitulo from "@/components/powerTitulo.vue";

export default {
    components: {
        "v-menu-lateral-apendice": menuLateral,
        "v-power-titulo": powerTitulo
    },
    created() {
        window.getApp.$emit("APP_DRAWER_HIDE");
    },

    data: () => ({
        fab: false,
        editable: true,
        url_active: location.href,                                  
        url_actions: "apendices/",
        url_list: "apendices/lista/",
        tabla: 25,
        title: "TIPOS DE DOCUMENTOS",
        columns: ["clave", "descripcion","recibe_facturas","recibe_layouts",
            //"layouts", 
            "actions"],
        options: {
            filterable: ["clave", "descripcion","recibe_facturas","recibe_layouts"],
            sortable: ["clave", "descripcion","recibe_facturas","recibe_layouts"],

            headings: {
                clave: "Clave",
                descripcion: "Descripción",
                recibe_facturas: "Recibe Facturas xml",
                recibe_layouts: "Recibe Layouts xlsx",
                //layouts:"Layouts",
                actions: "Operaciones"
            }
        },
        camposexcel: {
            Clave: "clave",
            Descripción: "descripcion",
            "Recibe Facturas xml": "recibe_facturas",
            "Recibe Layouts xlsx": "recibe_layouts",
        },
        encabezadoLayout: {
            clave: "clave",
            descripcion: "descripcion",
            recibe_facturas: "recibe_facturas",
            recibe_layouts: "recibe_layouts"
        },
        camposLayout: [{
            clave: "[Clave del Tipo de Documento]",
            descripcion: "[Descripción del Tipo de Documento]",
            recibe_facturas: "[1 si recibe facturas xml, 0 si no]",
            recibe_layouts: "[1 si recibe layouts xslx, 0 si no]",
        }],
        loading: false,
        modal: false,
        update: false,
        model: {
            id: 0,
            clave: "",
            descripcion: "",
            recibe_facturas:0,
            recibe_layouts:0,
        },  
        items: [],
        camposObligatorios: {
            "clave": "Clave",
            "descripcion": "Descripción",
            "recibe_facturas": "Recibe Facturas",
            "recibe_layouts": "Recibe Layouts",
        },
        rules: {
            required: v => !!v || "Este campo es requerido",            
        },      
        breadcrumbs: [{
                text: "Inicio",
                disabled: false,
                to: "/home"
            },
            {
                text: "Utilerías",
                disabled: true,
                to: ""
            },
            {
                text: "Apéndices",
                disabled: true,
                to: ""
            }
        ],

        //LAYOUT PARA FACTURAS XLSX DE TIPO DOCUMENTO (170, CFDI IMPO, CFDI EXPO, P018, P019, P021)
        encabezadoFacturaLayout: {
            tax_id:"tax_id",	
            fecha:"fecha",
            numero:"numero",	
            secuencia:"secuencia",
            concepto:"concepto",
            descripcion:"descripcion",
            cantidad:"cantidad",
            um:"um",
            valor_unitario:"valor_unitario",
            subtotal:"subtotal",
            total_facturado:"total_facturado",	
            clave_moneda:"clave_moneda",
        },
        //van vacíos para solo descargar layout con encabezados
        camposFactura170: [{
            tax_id:"[RFC o Tax ID del emisor]",	
            fecha:"[Fecha de Expedición en formato AAAA-MM-DD]",
            numero:"[Número de Factura]",	
            secuencia:"[Número de Partida secuencia de Factura]",
            concepto:"[Item o número de parte]",
            descripcion:"[Descripción de mercancía]",            
            cantidad:"[Cantidad]",
            um:"[Unidad de Medida]",
            valor_unitario:"[Valor en USD o MXN]",
            subtotal:"[Valor en USD o MXN]",
            total_facturado:"[Valor en USD o MXN]",	
            clave_moneda:"[Clave USD o MXN]",
        }],
        //LAYOUT PARA FACTURAS XLSX DE TIPO DOCUMENTO (P020)
        //van vacíos para solo descargar layout con encabezados
        camposFacturaP020: [{
            tax_id:"[RFC o Tax ID del emisor]",	
            fecha:"[Fecha de Expedición en formato AAAA-MM-DD]",
            numero:"[Número de Factura]",	
            secuencia:"[Número de Partida secuencia de Factura]",
            concepto:"[Seguros | Fletes | Maniobras | Otros]",
            descripcion:"[Descripción del incrementable]",
            cantidad:"[Cantidad]",
            um:"[Unidad de Medida]",
            valor_unitario:"[Valor en USD o MXN]",
            subtotal:"[Valor en USD o MXN]",
            total_facturado:"[Valor en USD o MXN]",	
            clave_moneda:"[Clave USD o MXN]",
        }],
        
    }),
    computed: {
        datafiltered() {
            if (this.$refs.principalTable != null) {                
                return this.$refs.principalTable.allFilteredData;
            } else {
                return this.items;
            }
        }
    },
    methods: {
        verificaClave170:function(clave){            
            return ['170','CFDI IMPO','CFDI EXPO','P018','P019','P021'].includes(clave);            
        },
        verificaClaveP020:function(clave){
            return ['P020'].includes(clave);
        },
        verificaLongitud: function(value){ 
            if (value.toString().length != 3 ){
                return "Deben ser 3 dígitos";
            } 
            return true;
        },
        verificaLongitud2: function(value){ 
            if (value.toString().length != 2 ){
                return "Deben ser 2 caracteres";
            } 
            return true;
        },
        verificaLongitud3: function(value){ 
            if (value.toString().length != 3 ){
                return "Deben ser 3 caracteres";
            } 
            return true;
        },
        soloNumeros: function(campo){ 
            const pattern = /^[\d]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloNumeros(campo);                
            }                      
        },
        soloNumerosLetras: function(campo){ 
            const pattern = /^[\a-zA-Z0-9]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloNumerosLetras(campo);                
            }             
        },
        soloLetras: function(campo){ 
            const pattern = /^[\a-zA-Z]*$/;
            let value = this.model[campo];
            if (!pattern.test(value) ){
                this.model[campo] = this.model[campo].substring(0,this.model[campo].length-1);
                this.soloLetras(campo);                
            }             
        },
        openModal: function (type) {
            if (type === 1) {
                this.limpiarModel();                
                this.update = false;
            } else {                
                this.update = true;
            }
            this.modal = true;
        },
        limpiarModel: function () {
            for (var k in this.model) {
                this.model[k] = "";
            }            
        },

        guardar() {
            if (!this.$refs.form.validate()) {
                //Alguna operación o mensaje
            } else {
                this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");                
                const datos = this.model;
                if(datos["recibe_facturas"]!= undefined && datos["recibe_facturas"]==""){
                    datos["recibe_facturas"]= 0;
                }
                if(datos["recibe_layouts"]!= undefined && datos["recibe_layouts"]==""){
                    datos["recibe_layouts"]= 0;
                }                
                datos["tabla"] = this.tabla;
                
                var metodo = "post";
                var urlCliente = this.URL;
                if (this.update == true) {
                    metodo = "put";
                    urlCliente += this.model.id + "/";
                }
                axios({
                        method: metodo,
                        url: urlCliente,
                        data: datos
                    })
                    .then(res => {
                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "Los datos se guardaron correctamente",
                            footer: ""
                        });
                        this.cargar();                        
                        this.modal = false;
                    })
                    .catch(error => {
                        var errores = "";
                        if (typeof error.response.data != "undefined") {
                            Object.keys(error.response.data).forEach(function (key) {
                                for (var k in error.response.data[key]) {
                                    errores += key + ": " + error.response.data[key][k];
                                    errores += "<br>";
                                }
                            });
                        }
                        this.$swal({
                            position: "center",
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al guardar los datos",
                            footer: errores
                            //showConfirmButton: false,
                        });
                        this.$root.$dialogLoader.hide();
                        
                    });
            }
        },
        
        cargar: function () {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
           var datos = {
                tabla: this.tabla
            };
            axios
                .post(this.$hostname + this.url_list, datos)                
                .then(res => {
                    if (typeof res.data !== "undefined") {
                        this.items = res.data;
                        for( var k in this.items){
                            if(this.items[k].recibe_facturas!=undefined && this.items[k].recibe_facturas==1)
                                this.items[k].recibe_facturas = "Si";
                            else
                                this.items[k].recibe_facturas = "No";
                            
                            if(this.items[k].recibe_layouts!=undefined && this.items[k].recibe_layouts==1)
                                this.items[k].recibe_layouts = "Si";
                            else
                                this.items[k].recibe_layouts = "No";
                        }
                    }
                })
                .catch(err => {
                  
                    console.log(err);
                })
                .then(() => {
                    this.$root.$dialogLoader.hide();
                });
        },
       
        getRegistro: function (id_registro) {
            this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
            axios
                .get(this.URL + id_registro + "/", {
                    params: {
                        tabla: this.tabla
                    }
                })
                .then(response => {
                    this.model = response.data;                    
                    this.openModal(2); //ACTUALIZAR
                })
                .catch(error => {
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: "Ocurrió un error al obtener el registro",
                        footer: ""
                    });
                }).then(()=>{
                    this.$root.$dialogLoader.hide();
                });
        }, //getRegistro

        deleteRegistro: function (id_registro) {
            this.$swal({
                type: "info",
                title: "Cuidado",
                text: "¿Está seguro de eliminar el registro?",
                footer: "",
                showCancelButton: true,
                cancelButtonColor: "#d33",
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar"
            }).then(result => {
                if (result.value){
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    axios
                    .delete(this.URL + id_registro + "/", {
                            params: {
                                tabla: this.tabla
                            }
                        })
                    .then(response => {
                        this.cargar();
                        this.$swal({
                            type: "success",
                            title: "Operación Exitosa",
                            text: "El registro se eliminó correctamente.",
                            footer: ""
                        });
                    })
                    .catch(error => {
                        this.$root.$dialogLoader.hide();
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al eliminar el registro",
                            footer: ""
                        });
                    });
                }
                    
            });
        }, //delete
        
        beforeUpload(file) {
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (isLt2M) {
                return true;
            }
            this.$swal({
                type: "warning",
                title: "¡Operación no Permitida!",
                text: "El archivo no debe ser mayor a 2MB.",
                footer: ""
            });
            return false;
        },
        verificaObligatorios: function (results) {
            var errores = '';
            var keys = [];
            for (var k in results) {
                keys.push(k);
            }

            for (var key in this.camposObligatorios) {
                if (keys.indexOf(key) == -1)
                    errores += '<br/>' + "- El campo '" + key + "' es obligatorio.";
            }

            return errores == '' ? true : errores;
        },
        validaCargaLayout: async function (results) {
            var thisObject = this;
            //return new Promise(function(resolve, reject){
            var errores = 0;
            var renglonesLeidos = 0;
            var erroresText = "";
            const pattern = /^[\d]*$/;            
            try {
                for (var k in results) {
                    renglonesLeidos++;
                    results[k]["user_updated"] = thisObject.$local_storage.get("email");                    
                    var obligatorios = thisObject.verificaObligatorios(results[k]);
                    if (obligatorios !== true) {
                        errores++;
                        if (erroresText.indexOf(obligatorios) == -1)
                            erroresText += obligatorios;
                    } else {
                        if ( results[k]['clave'].toString().length > 10 ){
                            errores++;
                            erroresText += "- Clave \"" + results[k]["clave"] + "\" no debe ser mayor a 10 caracteres <br>";
                        }
                        if ( results[k]['descripcion'].toString().length > 250 ){
                            errores++;
                            erroresText += "- Descripción \"" + results[k]["descripcion"] + "\" no debe ser mayor a 250 caracteres <br>";
                        }

                        if ( results[k]['recibe_facturas'].toString().length != 1 ){
                            errores++;
                            erroresText += "- Recibe facturas \"" + results[k]["recibe_facturas"] + "\" debe ser de 1 dígito [0 o 1]<br>";
                        } else if (!pattern.test(results[k]['recibe_facturas'].toString())){
                            errores++;
                            erroresText += "- Recibe facturas \"" + results[k]["recibe_facturas"] + "\" debe ser de 1 dígito [0 o 1]<br>";
                        } else {
                            if (results[k]['recibe_facturas'].toString()=="1")
                                results[k]['recibe_facturas'] = 1;
                            else
                                results[k]['recibe_facturas'] = 0; 
                        }

                        if ( results[k]['recibe_layouts'].toString().length != 1 ){
                            errores++;
                            erroresText += "- Recibe layouts \"" + results[k]["recibe_layouts"] + "\" debe ser de 1 dígito [0 o 1]<br>";
                        } else if (!pattern.test(results[k]['recibe_layouts'].toString())){                              
                            errores++;
                            erroresText += "- Recibe layouts \"" + results[k]["recibe_layouts"] + "\" debe ser de 1 dígito [0 o 1]<br>";
                        } else {
                            if (results[k]['recibe_layouts'].toString()=="1")
                                results[k]['recibe_layouts'] = 1;
                            else
                                results[k]['recibe_layouts'] = 0;                             
                        }

                    }                    
                    
                }

                if (renglonesLeidos == 0) {
                    errores++;
                    erroresText +=
                        "- No hay datos en el layout. Verifique que exista información a partir del 3er renglón.\n";
                }

                return {
                    errores: errores,
                    erroresText: erroresText
                };
            } catch (error) {
                console.log(error);
                thisObject.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
            }
            //}); //promise
        },
        handleSuccess: async function ({
            results,
            header
        }) {
            var errores = 0;
            var erroresText = "";            
            try {
                let validaciones = await this.validaCargaLayout(results);
                if (validaciones.errores > 0) {
                    this.$swal({
                        type: "warning",
                        title: "¡Operación no Permitida!",
                        text: "Existen errores al cargar el archivo. Corrija y vuelva a intentarlo.",
                        footer: validaciones.erroresText
                    });
                    
                } else {
                    this.$root.$dialogLoader.show("ESPERE UN MOMENTO POR FAVOR..");
                    var resultadoFinal = [];
                    for (var k in results) {
                        
                        var item = {
                            clave: results[k]["clave"].toString().toUpperCase(),
                            descripcion: results[k]["descripcion"],
                            recibe_facturas: results[k]["recibe_facturas"],
                            recibe_layouts: results[k]["recibe_layouts"],
                            user_updated: results[k]["user_updated"]
                        };
                        resultadoFinal.push(item);
                    }
                    
                    axios
                        .post(this.URL + "importar_apendice/?tabla=" + this.tabla, resultadoFinal)
                        .then(() => {
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "Los datos se guardaron correctamente",
                                footer: ""
                            });
                        })
                        .catch(err => {
                            var errores = "";
                            if (typeof err.response.data != "undefined") {
                                for (var i = 0; i < err.response.data.length; i++) {
                                    Object.keys(err.response.data[i]).forEach(function (key) {
                                        errores +=
                                            "Fila " +
                                            (i + 3) +
                                            " => " +
                                            key +
                                            ": " +
                                            err.response.data[i][key];
                                        errores += "<br>";
                                    });
                                }
                            }
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Verifique que los encabezados correspondan con el layout y que no existan registros duplicados.",
                                footer: errores
                            });
                        })
                        .then(() => {
                            this.cargar();                                                        
                        });
                }
            } catch (error) {
                this.$swal({
                    type: "warning",
                    title: "¡Operación no Permitida!",
                    text: "Error al cargar el archivo. Verifique que no existan celdas vacías.",
                    footer: error.message
                });
                this.$root.$dialogLoader.hide();
            }
        },  

    }, //methods

    created: function () {        
        this.URL = this.$hostname + this.url_actions;        
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        if (this.$local_storage.get("id_cliente") > 0) {
            this.editable = false;
            delete this.options.headings["actions"];
            var key = 0;
            for (var k in this.columns) {
                if (this.columns[k] == "actions") key = k;
            }
            if (key > 0) delete this.columns[key];
        }
        this.cargar();     
    }
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>